import React, { useState } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

import FileUploaderSingle from "../../../../core/components/fileUploader/FileUploaderSingle";


const ImageSelector = ({files, setFiles}) => {

  return (
    <ImgSelectorWrapper>
    <FileUploaderSingle files={files} setFiles={setFiles}/>
    </ImgSelectorWrapper>
  );
};

const ImgSelectorWrapper = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgroundSidebar};
  border-radius: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

// const ImgUploaderStyle = styled.div`
//   width:  100%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-top: 1rem;
//   padding: 2rem;
// `;

// const ImageHolderStyle = styled.div`
//   width : 40%;
//   height: 150px;
//   background-color: red;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   border-radius: 1rem;
//   margin-top: 1rem;
  
//   img {
//     width : 100%;
//     height: 100%;
//     object-fit : cover;
//   }

// `;

     {/* <ImageHolderStyle>
        <img
          className="rounded me-50 img-responsive"
          src={imageAvatar}
          alt="Generic placeholder image"
          height="100"
          width="100"
        />
      </ImageHolderStyle>
      <ImgUploaderStyle>
        <Button tag={Label} className="mb-75 me-75" size="sm" color="primary">
          آپلود
          <Input
            type="file"
            // onChange={onChangeImage}
            hidden
            accept="image/png"
          />
        </Button>
        <Button
          className="mb-75"
          color="secondary"
          size="sm"
          outline
          onClick={handleImgReset}
        >
          حذف
        </Button>
      </ImgUploaderStyle> */}

export default ImageSelector;
